import CommonForms from '@/request/api/commonForms';
import Calculation from '@/request/api/calculation';
import OtherPage from '@/request/api/otherPage';
import LoanSupermarket from '@/request/api/LoanSupermarket';
import CheckAmount from '@/request/api/checkAmount';
import PublicPage from '@/request/api/publicPage';
import InteligentMatchPage from '@/request/api/inteligentMatchPage';

export default {
  CommonForms,
  Calculation,
  OtherPage,
  LoanSupermarket,
  CheckAmount,
  PublicPage,
  InteligentMatchPage,
};
